import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
`;

interface SkeletonProps {
  width?: string;
  height?: string;
}

export const Skeleton = styled.span<SkeletonProps>`
  display: inline-block;
  width: ${(props) => props.width ?? "100%"};
  height: ${(props) => props.height ?? "1rem"};
  border-radius: 0.375rem;
  background: linear-gradient(
    90deg,
    var(--surface-3) 25%,
    var(--surface-2) 50%,
    var(--surface-3) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
